import { SiteSelectionContent } from "./SiteSelectionContent";

export default SiteSelectionContent;
